import { HorizontalGroup } from '@libs/uikit/Components';
import styled from 'styled-components';

export const HG = styled(HorizontalGroup)`
    width: 100%;
    padding: 0;
    margin: 0;

    & > * {
        margin: 0;
        padding: 0;
    }
`;
